/* tslint:disable */
/* eslint-disable */
/**
 * Muisti API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Exhibition
 */
export interface Exhibition {
    /**
     * 
     * @type {string}
     * @memberof Exhibition
     */
    readonly id?: string;
    /**
     * 
     * @type {string}
     * @memberof Exhibition
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof Exhibition
     */
    readonly creatorId?: string;
    /**
     * 
     * @type {string}
     * @memberof Exhibition
     */
    readonly lastModifierId?: string;
    /**
     * Created date
     * @type {Date}
     * @memberof Exhibition
     */
    readonly createdAt?: Date;
    /**
     * Date modified
     * @type {Date}
     * @memberof Exhibition
     */
    readonly modifiedAt?: Date;
}

export function ExhibitionFromJSON(json: any): Exhibition {
    return ExhibitionFromJSONTyped(json, false);
}

export function ExhibitionFromJSONTyped(json: any, ignoreDiscriminator: boolean): Exhibition {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': json['name'],
        'creatorId': !exists(json, 'creatorId') ? undefined : json['creatorId'],
        'lastModifierId': !exists(json, 'lastModifierId') ? undefined : json['lastModifierId'],
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        'modifiedAt': !exists(json, 'modifiedAt') ? undefined : (new Date(json['modifiedAt'])),
    };
}

export function ExhibitionToJSON(value?: Exhibition | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
    };
}


